import React, { useState } from "react";
import axios from "axios";
import {
  Bottom,
  Button,
  Input,
  NewsLetter,
  Sub,
  Subscribe,
  Subsription,
  Top,
  Done,
} from "./Subscribe.Elements";

const SubscribeSection = () => {
  const [userEmail, setUserEmail] = useState("");
  const [isEmailSaved, setIsEmailSaved] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const emailFeed = {
        email_address: userEmail,
      };
      const res = await axios.post("https://sumail-code.onrender.com/api/v1/emails", emailFeed);
      setIsEmailSaved(true);
      // console.log(`${res.data.savedEmail.email_address} is saved in DB`);
    } catch (err) {
      console.log(err);
    }
    setUserEmail("");
  };

  setTimeout(() => {
    setIsEmailSaved(false);
  }, 10000);

  return (
    <Subsription>
      <NewsLetter>
        <Top>Subscribe for NewsLetter</Top>
        <Sub>Latest Blogs in your Inbox!</Sub>
        <Bottom>
          <Subscribe onSubmit={handleSubmit}>
            <Input
              type='email'
              onChange={(e) => setUserEmail(e.target.value)}
              value={userEmail}
              placeholder='Email'
            />
            <Button type='submit'>Subscribe</Button>
          </Subscribe>
        </Bottom>
        {isEmailSaved && <Done>subscribed</Done>}
      </NewsLetter>
    </Subsription>
  );
};

export default SubscribeSection;
